import script from "./MoreBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreBtn.vue?vue&type=script&setup=true&lang=js"

import "./MoreBtn.vue?vue&type=style&index=0&id=566e1770&lang=css"

const __exports__ = script;

export default __exports__